import { routeTo } from 'app/util/routeUtils';

/**
 * Handle relative and absolute links on both web and mobile.
 */
export const onPressLink = (url) => (event) => {
  event?.preventDefault();
  routeTo(url);
};
